import $ from 'jquery';

import _ from 'underscore';
import {
  CONTEXTUAL_ENTITY_TYPE,
} from '@bingads-webui-campaign/recommendation-core';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { AdGroupEditorView } from '@bingads-webui-campaign/recommendation-popupeditor';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';

import template from './campaign-ad-group-column.pug';
import {
  isPopupEditorEnabledRecommendationType,
} from '../const';

export class CampaignAdGroupColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, recommendationType, view, deps: {
      appConfig, jsdata, dataManager,
    }, isMCC,
  }) {
    super({
      name: 'CampaignAdGroup',
      property: 'Target/CampaignAdGroupName',
      title: i18n.getString('Recommendation_ColumnName_CampaignAdGroup'),
      bodyClasses: ['grid-column-campaignAdGroupName', 'actionable'],
      colClasses: ['col-longText'],
      sortable: 'Target/CampaignName',
      type: 'string',
      editable: isPopupEditorEnabledRecommendationType(recommendationType),
    });

    this.i18n = i18n;
    this.recommendationType = recommendationType;
    this.view = view;
    this.appConfig = appConfig;
    this.jsdata = jsdata;
    this.dataManager = dataManager;
    this.isMCC = isMCC;
    this.edmCampaign = edm;
  }

  template({
    value: {
      Target: {
        CampaignName,
        CampaignId,
      },
      Opportunities,
    },
  }) {
    return template({
      AdGroupName: Opportunities[0].Target.AdGroupName,
      CampaignName,
      entityId: CampaignId,
      entityCampaignId: CampaignId,
      entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'Target/CampaignAdGroupName',
    };
  }

  onPrompt({
    event,
    item,
    newPosition,
  }) {
    if ($(event.target).is('a')) {
      return undefined;
    }

    const key = $(event.target).parents('tr[data-key]').data('key');

    const {
      i18n, recommendationType, view, dataManager, isMCC,
    } = this;

    const adGroupEditorView = new AdGroupEditorView({
      i18n,
      item,
      recommendationType,
      key,
      view,
      dataManager,
      isMCC,
      newPosition,
    });

    const editorView = new GridCustomizedPopupEditor({
      editorView: adGroupEditorView.render(),
      cellPosition: newPosition,
      renderBelow: false,
      className: 'grid-popupeditor',
      parentContainerSelector: '.grid-and-disclaim-container',
    });

    return editorView.render();
  }
}
